import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { switchMap, map, catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { LiveNursesService } from 'src/app/recruiting/candidates/live-nurses-new/live-nurses.service';
import * as actions from 'src/app/recruiting/candidates/live-nurses-new/store/live-nurses.actions';
import { ToasterService } from 'src/app/shared/services/toaster.service';

@Injectable()
export class AddNoteEffect {
    addNote$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.addNote),
            switchMap((action) => {
                return this.liveNursesService.addNote(action.note).pipe(
                    map((response) => actions.addNoteSuccess({ note: response })),
                    catchError((error) => of(actions.addNoteFail({ error })))
                );
            })
        )
    );

    addNoteFail$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(actions.addNoteFail),
                tap((action) => {
                    console.log(action.error);
                    this.toaster.toast('Sorry. A problem occurred while adding a note.');
                })
            ),
        { dispatch: false }
    );

    constructor(
        private readonly actions$: Actions,
        protected readonly liveNursesService: LiveNursesService,
        private readonly toaster: ToasterService
    ) {}
}
